import React from "react";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion, AnimatePresence } from "framer-motion";

interface WorksheetAcknowledgmentProps {
  hasAcknowledged: boolean;
  onAcknowledge: () => void;
  buttonRef: React.RefObject<HTMLButtonElement>;
}

const WorksheetAcknowledgment: React.FC<WorksheetAcknowledgmentProps> = ({
  hasAcknowledged,
  onAcknowledge,
  buttonRef,
}) => {
  const [expanded, setExpanded] = React.useState(false);

  const handleToggle = () => {
    if (hasAcknowledged) {
      setExpanded((prev) => !prev);
    }
  };

  return (
    <div className="bg-yellow-50 border-2 border-yellow-400 p-4 mb-8 rounded-xl">
      <div className="flex cursor-pointer" onClick={handleToggle}>
        <div className="flex-shrink-0">
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className="text-yellow-400 text-[20px]"
          />
        </div>
        <div className="ml-3 mt-0.5">
          <h3 className="text-sm font-medium text-yellow-800">
            PLEASE READ AND ACKNOWLEDGE PRIOR TO YOUR SUBMISSION
          </h3>
          <AnimatePresence>
            {(!hasAcknowledged || expanded) && (
              <motion.div
                key="content"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.3 }}
                style={{ overflow: "hidden" }}
              >
                <div className="mt-2 text-sm text-yellow-700">
                  <p className="mb-4">
                    We are currently prioritizing the purchase of the following
                    Note product.
                  </p>
                  <p className="mb-4">
                    We are purchasing Notes collateralized by properties that:
                  </p>
                  <ol className="list-decimal pl-5 space-y-2">
                    <li>Are secured by residential 1 to 4 units.</li>
                    <li>Are less than ½ acre – Not rural.</li>
                    <li>Are 5-bedroom, 3-bathroom or less.</li>
                    <li>Are 2800 sf or less.</li>
                    <li>Have an ARV under the FHA cap.</li>
                  </ol>
                  <p className="mt-4 mb-4">Additionally, the Note should:</p>
                  <ol className="list-decimal pl-5 space-y-2">
                    <li>Not exceed 70% LTV.</li>
                    <li>
                      Be in 1st lien position with a 15% or greater yield – can
                      be achieved through discounting or,
                    </li>
                    <li>
                      Be in 2nd lien position with a 30% or greater yield – can
                      be achieved through discounting.
                    </li>
                    <li>
                      Be non-owner occupied - will consider owner-occupied for
                      higher yields.
                    </li>
                  </ol>
                  <p className="mt-4">
                    If your Note does not fit within the above criteria, please submit
                    it to an alternate buyer.
                  </p>
                  <p className="mt-4">
                    Thank you for considering ThePaperBroker.com for your Note
                    submission.
                  </p>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
      {!hasAcknowledged && (
        <div className="flex-shrink-0 w-full flex justify-center mt-4">
          <button
            ref={buttonRef}
            type="button"
            className="inline-flex items-center justify-center rounded-md border border-transparent bg-yellow-500 px-6 py-2 text-sm font-bold text-white hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 transition-transform"
            onClick={onAcknowledge}
          >
            Acknowledge
          </button>
        </div>
      )}
    </div>
  );
};

export default WorksheetAcknowledgment;
